import { create } from "zustand";
import { persist } from "zustand/middleware";

interface PropertyState {
  selectedPropertyId: string | null;
  setSelectedPropertyId: (id: string | null) => void;
}

/**
 * Currently selected property for property-scoped admin screens.
 * Persisted to localStorage so a refresh keeps the operator on the same property.
 */
export const usePropertyStore = create<PropertyState>()(
  persist(
    (set) => ({
      selectedPropertyId: null,
      setSelectedPropertyId: (id) => set({ selectedPropertyId: id }),
    }),
    { name: "meshcore-admin-property" }
  )
);

/** Reactive read of the selected property id (null when none selected). */
export function useSelectedProperty(): string | null {
  return usePropertyStore((s) => s.selectedPropertyId);
}
